<template>
<b-tab :title="$t('WORKPLANNERWIN')" @click="getData()">
  <div class="animated fadeIn">
    <div class="">
      <div class="">
        <div class="row mb-2">
          <div class="col-12">
            <button type="button" class="btn button-add btn-primary pull-right" @click="showModal()">{{$t('NEW')}}</button>
          </div>
        </div>
        <div class="row">
          <div class="card-body table-logoped" v-if="response.root != null">
              <grid
                  :data="response.root"
                  ref="workPlaner"
                  v-model="pagination"
                  :columns="columns"
                  :totalCount="response.totalCount"
                  gridId="workPlanerGrid">
                    <template v-slot="{item, column}">
                        <template v-if="column.id == 'actions'">
                            <button type="button" class="btn button-edit mr-2"  @click="showModal(item)">{{$t('EDIT')}}</button>
                        <button type="button" class="btn button-dlt" @click="deleteRow(item.workPlannerId)">{{$t('DELETE')}}</button>
                        </template>
                    </template>
              </grid>
          </div>
    </div>
      </div>
    </div>
    <b-modal ref="formmodal" :title="$t('WORKPLANNERFORM')" ok-title="submit" hide-footer no-close-on-backdrop>
      <div class="d-block">
        <workplannerform v-bind:formData="formData" v-bind:formError="formError"></workplannerform>
      </div>
      <div class="text-right">
        <b-btn class="btn button-cancel" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="btn button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
  </div>
</b-tab>
</template>

<script>
import Api from '@/api/child/WorkPlanner';
import WorkPlannerForm from './WorkPlannerForm.vue';

export default
{
    name: 'WorkPlanner',
    props: ['childId'],
    components:
  {
      workplannerform: WorkPlannerForm,
  },
    data()
    {
        const me = this;
        return {
            columns: [
                {
                    key: 'goals',
                    name: me.$t('GOALS'),
                },
                {
                    key: 'period',
                    name: me.$t('PERIOD'),
                },
                {
                    key: 'evaluation',
                    name: me.$t('EVALUATION'),
                },
                {
                    id: 'actions',
                    name: me.$t('ACTIONS'),
                },
            ],
            response:
      {},
            formError:
      {},
            formData:
      {
          goals: '',
          period: '',
          evaluation: '',
      },
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 25,
          searchTimeout: false,
          initialId: null,
          sort: null,
          readingType: null,
      },
        };
    },
    created()
    {

    },
    methods:
  {
      async getData()
      {
          const me = this;
          try
          {
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              me.response = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async deleteRow(id)
      {
          const me = this;
          try
          {
              me.$store.commit('setModalAlert',
                  {
                      text: me.$i18n.t('AREYOUSHURE'),
                      async btnAction()
                      {
                          const data = await Api.deleteRow(
                              {
                                  id,
                              },
                          );
                          me.$notify.notice(data);
                          await me.getData();
                      },
                  });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      showModal(item)
      {
          const me = this;
          if (typeof item !== 'undefined')
          {
              me.formData = item;
          }
          this.$refs.formmodal.show();
      },
      async submitData(item)
      {
          const me = this;
          try
          {
              if (typeof item.workPlannerId !== 'undefined')
              {
                  item.id = item.workPlannerId;
                  delete (item.workPlannerId);
              }

              item.childId = me.childId;
              const data = await Api.submitData(item);
              if (data.error)
              {
                  me.$notify.notice(data);
                  me.formError = data;
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideModal();
                  await me.getData();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      hideModal()
      {
          const me = this;
          this.$refs.formmodal.hide();

          me.formData = {
              goals: '',
              period: '',
              evaluation: '',
          };
      },
  },
    watch:
  {
      pagination:
    {
        deep: true,
        handler()
        {
            const me = this;

            if (me.searchTimeout !== false)
            {
                clearTimeout(me.searchTimeout);
            }

            me.searchTimeout = setTimeout(() =>
            {
                me.getData();
                me.searchTimeout = false;
            }, 300);
        },
    },
  },
    computed:
  {
      getParams()
      {
          const me = this;
          const data = {
              ...me.pagination,
          };
          data.start = (data.currentPage - 1) * data.limit;
          data.childId = me.childId;
          return data;
      },
  },
};
</script>
